import React from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { useIntl } from "react-intl";
import { createEntity, entitySelector, updateEntity } from "../../slice";
import AbstractForm from "./view";
import { filterNestedEntity } from "../AbstractTable/container";

// Removes non form fields
const clearFormFields = (entity, formFields) => {
    const entityClone = { ...entity };

    Object.keys(entityClone).forEach((key) => {
        if (!formFields.some((field) => field.name === key)) {
            delete entityClone[key];
        }
    });

    return entityClone;
};

function AbstractFormContainer({
    options,
    entityObject,
    includedEntities,
    onFinish,
    onCancel = onFinish,
    isNested = !!options.url,
}) {
    const { hasErrors, isLoading } = useSelector(entitySelector(options.entityName));
    const dispatch = useDispatch();
    const intl = useIntl();

    const onFormSave = async (_entityObject) => {
        if (entityObject && entityObject.id) {
            await dispatch(updateEntity(options.entityName, entityObject.id, _entityObject));
            onFinish();
        } else {
            const entity = clearFormFields(
                { ...entityObject, ..._entityObject },
                options.formFields
            );

            await dispatch(createEntity(options.entityName, entity, onFinish));
        }
    };

    const localizedDisplayName = intl.formatMessage({
        id: `flyout-form.${_.kebabCase(options.displayName || options.entityName)}`,
    });
    const header =
        entityObject && entityObject.id
            ? intl.formatMessage(
                { id: "flyout-form.edit-title" },
                { entity: localizedDisplayName, number: entityObject.id }
            )
            : intl.formatMessage(
                { id: "flyout-form.create-title" },
                { entity: localizedDisplayName }
            );

    return (
        <AbstractForm
            header={header}
            options={{
                ...options,
                formFields: options.formFields.map((field) =>
                    !filterNestedEntity(field, entityObject) && isNested
                        ? { ...field, disabled: true }
                        : field
                ),
            }}
            entityObject={entityObject}
            includedEntities={includedEntities}
            onCancel={() => onCancel(null)}
            isLoading={isLoading}
            hasErrors={hasErrors}
            onSave={onFormSave}
        />
    );
}

export default AbstractFormContainer;
